import { uniqueId } from 'lodash';
import { useMemo } from 'react';
import ReactQuill from 'react-quill'
import "react-quill/dist/quill.snow.css";

interface RichTextEditorProps {
    placeholder: string,
    value: string,
    onChange: (value: string) => void,
    onBlur?: () => void,
    id?: string,
    noBorder?: boolean,
    disabled?: boolean
}

const RichTextEditor: React.FC<RichTextEditorProps> = ({ placeholder, value, onChange, onBlur = () => void 0, noBorder = false, disabled=false }) => {
    const memoizedId = useMemo(() => uniqueId('rich-text'), []);

    const modules = {
        toolbar: {
            container: `#${memoizedId}-toolbar`,
        },
    };


    return (
        <div className={`custom-editor ${noBorder ? 'no-border' : ''}`}>
            {/* Custom Toolbar */}
            <div id={`${memoizedId}-toolbar`}>
                <span className="ql-formats">
                    <button className="ql-italic"></button>
                    <button className="ql-bold"></button>
                    <button className="ql-underline"></button>
                </span>
                <span className="ql-formats">
                    <button className="ql-align" value=""></button>
                    <button className="ql-align" value="center"></button>
                    <button className="ql-align" value="right"></button>
                    <button className="ql-align" value="justify"></button>
                </span>
                <span className="ql-formats">
                    <button className="ql-list" value="ordered"></button>
                    <button className="ql-list" value="bullet"></button>
                </span>
                <span className="ql-formats">
                    <select className="ql-size" defaultValue="">
                        <option value="small"></option>
                        <option value=""></option>
                        <option value="large"></option>
                        <option value="huge"></option>
                    </select>
                </span>
            </div>
            <ReactQuill
                key={memoizedId}
                theme="snow"
                placeholder={placeholder}
                modules={modules}
                value={value}
                readOnly={disabled}
                onChange={(a) => {
                    onChange(a);
                }}
                onBlur={onBlur}
            />
        </div>
    )
}

export default RichTextEditor